import store from '../store'

export default async function auth(to, from, next) {
  if (store.getters['auth/token'] && !store.getters['auth/check']) {
    await store.dispatch('auth/fetchUser')
  }

  next()
}
